import React, { useEffect, useState } from "react";
import { Modal, Button, Row, Col, Form } from 'react-bootstrap';
import { useHistory, useParams, Link } from "react-router-dom";

import 
{ 
  FacebookShareButton,
  FacebookIcon,
  EmailShareButton,
  EmailIcon,
  LinkedinShareButton,
  LinkedinIcon,
  TwitterShareButton,
  TwitterIcon,
  WhatsappShareButton,
  WhatsappIcon
 }
 from "react-share";

const ShareButtonPopUp = (props) => {
    const { id } = useParams();
    var path = window.location.origin;
    const shareUrl = `${path}/detail/${id}`
    return (
        <Modal
            {...props}
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Share Button
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{margin:'0px 0px 0px 71px'}}>
                <FacebookShareButton
                    url={shareUrl}
                    target="_blank"
                    //quote={props.joke.setup + props.joke.punchline}
                    hashtag="#programing joke">
                    <FacebookIcon logoFillColor="white" />
                </FacebookShareButton>
                <EmailShareButton
                    url={shareUrl}
                    target="_blank"
                    //quote={props.joke.setup + props.joke.punchline}
                    hashtag="#programing joke">
                    <EmailIcon logoFillColor="white" />
                </EmailShareButton>
                <LinkedinShareButton
                    url={shareUrl}
                    target="_blank"
                    //quote={props.joke.setup + props.joke.punchline}
                    hashtag="#programing joke">
                    <LinkedinIcon logoFillColor="white" />
                </LinkedinShareButton>
                <TwitterShareButton
                    url={shareUrl}
                    target="_blank"
                    //quote={props.joke.setup + props.joke.punchline}
                    hashtag="#programing joke">
                    <TwitterIcon logoFillColor="white" />
                </TwitterShareButton>
                <WhatsappShareButton
                    url={shareUrl}
                    target="_blank"
                    //quote={props.joke.setup + props.joke.punchline}
                    hashtag="#programing joke">
                    <WhatsappIcon logoFillColor="white" />
                </WhatsappShareButton>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onHide}>Close</Button>
            </Modal.Footer>
        </Modal>
    );

}

export default ShareButtonPopUp;